export default {
    label: {
        salutation: {
            label: 'Salutation *',
            mr: 'Mr',
            mrs: 'Mrs'
        },
        firstName: 'First name *',
        lastName: 'Last name *',
        company: 'Company *',
        jobTitle: 'Job-title',
        email: 'Business email address *',
        phoneNumber: 'Business phone',
        acceptedTerms: {
            content: 'I have taken note of the {actionData} regulations and the {actionLegal} of TRENDONE GmbH.',
            actionData: 'data protection',
            actionLegal: 'terms and conditions',
            linkTermsAndConditions: 'https://www.trendone.com/en/general-terms-and-conditions',
            linkPrivacy: ' https://www.trendmanager.com/en/privacy/'
        },
        subscribeToNewsletter: 'I would like to receive the free trend preview and be informed monthly about three new micro trends and product updates. The newsletter can be cancelled at any time.',
        submit: 'Free test'
    },
    error: {
        salutation: {
            required: 'Please enter the salutation'
        },
        firstName: {
            required: 'Please enter your first name'
        },
        lastName: {
            required: 'Please enter your last name'
        },
        company: {
            required: 'Please enter the name of your company'
        },
        jobTitle: {
            required: 'Please enter your job title'
        },
        email: {
            required: 'Please enter your e-mail address',
            email: 'Please ensure the correct format of the e-mail address'
        },
        acceptedTerms: {
            required: 'Please accept the terms of use',
            mustBeTrue: 'Please accept the terms of use'
        }
    }
}
